/**
 * @generated SignedSource<<65f62fc7a4bda4cfa73c8babfdad3e49>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SearchFiltersScreenQuery$variables = Record<PropertyKey, never>;
export type SearchFiltersScreenQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SearchFiltersView_query">;
};
export type SearchFiltersScreenQuery = {
  response: SearchFiltersScreenQuery$data;
  variables: SearchFiltersScreenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "value",
    "storageKey": null
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
},
v3 = [
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": [
      "SEQUENCE_ASC"
    ]
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = [
  (v4/*:: as any*/),
  (v2/*:: as any*/),
  (v0/*:: as any*/)
],
v6 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isOther",
    "storageKey": null
  },
  (v4/*:: as any*/),
  (v2/*:: as any*/),
  (v0/*:: as any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SearchFiltersScreenQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "SearchFiltersView_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "SearchFiltersScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isMetricSystem",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isPlus",
            "storageKey": null
          },
          (v0/*:: as any*/),
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "orderBy",
                "value": [
                  "ACTIVITY_BY_ACTIVITY_ID__SEQUENCE_ASC"
                ]
              }
            ],
            "concreteType": "ActivityCriterionConnection",
            "kind": "LinkedField",
            "name": "activityCriteria",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ActivityCriterion",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "activityId",
                    "storageKey": null
                  },
                  (v0/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": "activityCriteria(orderBy:[\"ACTIVITY_BY_ACTIVITY_ID__SEQUENCE_ASC\"])"
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "orderBy",
                "value": [
                  "BELIEF_SYSTEM_BY_BELIEF_SYSTEM_ID__SEQUENCE_ASC"
                ]
              }
            ],
            "concreteType": "BeliefSystemCriterionConnection",
            "kind": "LinkedField",
            "name": "beliefSystemCriteria",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "BeliefSystemCriterion",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "beliefSystemId",
                    "storageKey": null
                  },
                  (v0/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": "beliefSystemCriteria(orderBy:[\"BELIEF_SYSTEM_BY_BELIEF_SYSTEM_ID__SEQUENCE_ASC\"])"
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "orderBy",
                "value": [
                  "CHILDREN_PREFERENCE_BY_CHILDREN_PREFERENCE_ID__SEQUENCE_ASC"
                ]
              }
            ],
            "concreteType": "ChildrenPreferenceCriterionConnection",
            "kind": "LinkedField",
            "name": "childrenPreferenceCriteria",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ChildrenPreferenceCriterion",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "childrenPreferenceId",
                    "storageKey": null
                  },
                  (v0/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": "childrenPreferenceCriteria(orderBy:[\"CHILDREN_PREFERENCE_BY_CHILDREN_PREFERENCE_ID__SEQUENCE_ASC\"])"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Criterion",
            "kind": "LinkedField",
            "name": "criterion",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "IntRange",
                "kind": "LinkedField",
                "name": "ageRange",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "IntRangeBound",
                    "kind": "LinkedField",
                    "name": "start",
                    "plural": false,
                    "selections": (v1/*:: as any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "IntRangeBound",
                    "kind": "LinkedField",
                    "name": "end",
                    "plural": false,
                    "selections": (v1/*:: as any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isRecentlyActive",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isLocationDealbreaker",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isVerified",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "maxDistanceInKm",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "maxDistanceInMi",
                "storageKey": null
              },
              (v2/*:: as any*/),
              (v0/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "orderBy",
                "value": [
                  "DEET_BY_DEET_ID__SEQUENCE_ASC"
                ]
              }
            ],
            "concreteType": "DeetCriterionConnection",
            "kind": "LinkedField",
            "name": "deetCriteria",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "DeetCriterion",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "deetId",
                    "storageKey": null
                  },
                  (v0/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": "deetCriteria(orderBy:[\"DEET_BY_DEET_ID__SEQUENCE_ASC\"])"
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "orderBy",
                "value": [
                  "EDUCATION_LEVEL_BY_EDUCATION_LEVEL_ID__SEQUENCE_ASC"
                ]
              }
            ],
            "concreteType": "EducationLevelCriterionConnection",
            "kind": "LinkedField",
            "name": "educationLevelCriteria",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "EducationLevelCriterion",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "educationLevelId",
                    "storageKey": null
                  },
                  (v0/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": "educationLevelCriteria(orderBy:[\"EDUCATION_LEVEL_BY_EDUCATION_LEVEL_ID__SEQUENCE_ASC\"])"
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "orderBy",
                "value": [
                  "GENDER_BY_GENDER_ID__SEQUENCE_ASC"
                ]
              }
            ],
            "concreteType": "GenderCriterionConnection",
            "kind": "LinkedField",
            "name": "genderCriteria",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "GenderCriterion",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "genderId",
                    "storageKey": null
                  },
                  (v0/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": "genderCriteria(orderBy:[\"GENDER_BY_GENDER_ID__SEQUENCE_ASC\"])"
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "orderBy",
                "value": [
                  "POLITICAL_VIEW_BY_POLITICAL_VIEW_ID__SEQUENCE_ASC"
                ]
              }
            ],
            "concreteType": "PoliticalViewCriterionConnection",
            "kind": "LinkedField",
            "name": "politicalViewCriteria",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PoliticalViewCriterion",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "politicalViewId",
                    "storageKey": null
                  },
                  (v0/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": "politicalViewCriteria(orderBy:[\"POLITICAL_VIEW_BY_POLITICAL_VIEW_ID__SEQUENCE_ASC\"])"
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "orderBy",
                "value": [
                  "RELATIONSHIP_TYPE_BY_RELATIONSHIP_TYPE_ID__SEQUENCE_ASC"
                ]
              }
            ],
            "concreteType": "RelationshipTypeCriterionConnection",
            "kind": "LinkedField",
            "name": "relationshipTypeCriteria",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RelationshipTypeCriterion",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "relationshipTypeId",
                    "storageKey": null
                  },
                  (v0/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": "relationshipTypeCriteria(orderBy:[\"RELATIONSHIP_TYPE_BY_RELATIONSHIP_TYPE_ID__SEQUENCE_ASC\"])"
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "orderBy",
                "value": [
                  "VACCINATION_STATUS_BY_VACCINATION_STATUS_ID__SEQUENCE_ASC"
                ]
              }
            ],
            "concreteType": "VaccinationStatusCriterionConnection",
            "kind": "LinkedField",
            "name": "vaccinationStatusCriteria",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "VaccinationStatusCriterion",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "vaccinationStatusId",
                    "storageKey": null
                  },
                  (v0/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": "vaccinationStatusCriteria(orderBy:[\"VACCINATION_STATUS_BY_VACCINATION_STATUS_ID__SEQUENCE_ASC\"])"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v3/*:: as any*/),
        "concreteType": "ActivityConnection",
        "kind": "LinkedField",
        "name": "activities",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Activity",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": (v5/*:: as any*/),
            "storageKey": null
          }
        ],
        "storageKey": "activities(orderBy:[\"SEQUENCE_ASC\"])"
      },
      {
        "alias": null,
        "args": (v3/*:: as any*/),
        "concreteType": "BeliefSystemConnection",
        "kind": "LinkedField",
        "name": "beliefSystems",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BeliefSystem",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": (v5/*:: as any*/),
            "storageKey": null
          }
        ],
        "storageKey": "beliefSystems(orderBy:[\"SEQUENCE_ASC\"])"
      },
      {
        "alias": null,
        "args": (v3/*:: as any*/),
        "concreteType": "ChildrenPreferenceConnection",
        "kind": "LinkedField",
        "name": "childrenPreferences",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ChildrenPreference",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": (v5/*:: as any*/),
            "storageKey": null
          }
        ],
        "storageKey": "childrenPreferences(orderBy:[\"SEQUENCE_ASC\"])"
      },
      {
        "alias": null,
        "args": (v3/*:: as any*/),
        "concreteType": "DeetConnection",
        "kind": "LinkedField",
        "name": "deets",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Deet",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": (v6/*:: as any*/),
            "storageKey": null
          }
        ],
        "storageKey": "deets(orderBy:[\"SEQUENCE_ASC\"])"
      },
      {
        "alias": null,
        "args": (v3/*:: as any*/),
        "concreteType": "EducationLevelConnection",
        "kind": "LinkedField",
        "name": "educationLevels",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "EducationLevel",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": (v5/*:: as any*/),
            "storageKey": null
          }
        ],
        "storageKey": "educationLevels(orderBy:[\"SEQUENCE_ASC\"])"
      },
      {
        "alias": null,
        "args": (v3/*:: as any*/),
        "concreteType": "GenderConnection",
        "kind": "LinkedField",
        "name": "genders",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Gender",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": (v6/*:: as any*/),
            "storageKey": null
          }
        ],
        "storageKey": "genders(orderBy:[\"SEQUENCE_ASC\"])"
      },
      {
        "alias": null,
        "args": (v3/*:: as any*/),
        "concreteType": "PoliticalViewConnection",
        "kind": "LinkedField",
        "name": "politicalViews",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PoliticalView",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": (v5/*:: as any*/),
            "storageKey": null
          }
        ],
        "storageKey": "politicalViews(orderBy:[\"SEQUENCE_ASC\"])"
      },
      {
        "alias": null,
        "args": (v3/*:: as any*/),
        "concreteType": "RelationshipTypeConnection",
        "kind": "LinkedField",
        "name": "relationshipTypes",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RelationshipType",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": (v5/*:: as any*/),
            "storageKey": null
          }
        ],
        "storageKey": "relationshipTypes(orderBy:[\"SEQUENCE_ASC\"])"
      },
      {
        "alias": null,
        "args": (v3/*:: as any*/),
        "concreteType": "VaccinationStatusConnection",
        "kind": "LinkedField",
        "name": "vaccinationStatuses",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "VaccinationStatus",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": (v5/*:: as any*/),
            "storageKey": null
          }
        ],
        "storageKey": "vaccinationStatuses(orderBy:[\"SEQUENCE_ASC\"])"
      }
    ]
  },
  "params": {
    "cacheID": "b858907c2991cc13768e5c9eb6a43c79",
    "id": null,
    "metadata": {},
    "name": "SearchFiltersScreenQuery",
    "operationKind": "query",
    "text": "query SearchFiltersScreenQuery {\n  ...SearchFiltersView_query\n}\n\nfragment ActivitiesMultiSelectInput_query on Query {\n  activities(orderBy: [SEQUENCE_ASC]) {\n    nodes {\n      name\n      rowId\n      id\n    }\n  }\n}\n\nfragment BeliefSystemsMultiSelectInput_query on Query {\n  beliefSystems(orderBy: [SEQUENCE_ASC]) {\n    nodes {\n      name\n      rowId\n      id\n    }\n  }\n}\n\nfragment ChildrenPreferencesMultiSelectInput_query on Query {\n  childrenPreferences(orderBy: [SEQUENCE_ASC]) {\n    nodes {\n      name\n      rowId\n      id\n    }\n  }\n}\n\nfragment DeetsMultiSelectInput_query on Query {\n  deets(orderBy: [SEQUENCE_ASC]) {\n    nodes {\n      isOther\n      name\n      rowId\n      id\n    }\n  }\n}\n\nfragment EducationLevelsMultiSelectInput_query on Query {\n  educationLevels(orderBy: [SEQUENCE_ASC]) {\n    nodes {\n      name\n      rowId\n      id\n    }\n  }\n}\n\nfragment GendersMultiSelectInput_query on Query {\n  genders(orderBy: [SEQUENCE_ASC]) {\n    nodes {\n      isOther\n      name\n      rowId\n      id\n    }\n  }\n}\n\nfragment MaxDistanceSliderInput_query on Query {\n  currentUser {\n    isMetricSystem\n    id\n  }\n}\n\nfragment PoliticalViewsMultiSelectInput_query on Query {\n  politicalViews(orderBy: [SEQUENCE_ASC]) {\n    nodes {\n      name\n      rowId\n      id\n    }\n  }\n}\n\nfragment RelationshipTypesMultiSelectInput_query on Query {\n  relationshipTypes(orderBy: [SEQUENCE_ASC]) {\n    nodes {\n      name\n      rowId\n      id\n    }\n  }\n}\n\nfragment SearchFiltersView_query on Query {\n  currentUser {\n    isMetricSystem\n    isPlus\n    id\n  }\n  ...ActivitiesMultiSelectInput_query\n  ...BeliefSystemsMultiSelectInput_query\n  ...ChildrenPreferencesMultiSelectInput_query\n  ...DeetsMultiSelectInput_query\n  ...EducationLevelsMultiSelectInput_query\n  ...GendersMultiSelectInput_query\n  ...MaxDistanceSliderInput_query\n  ...PoliticalViewsMultiSelectInput_query\n  ...RelationshipTypesMultiSelectInput_query\n  ...VaccinationStatusesMultiSelectInput_query\n  ...useActivityCriteria_query\n  ...useBeliefSystemCriteria_query\n  ...useChildrenPreferenceCriteria_query\n  ...useCriteria_query\n  ...useDeetCriteria_query\n  ...useEducationLevelCriteria_query\n  ...useGenderCriteria_query\n  ...usePoliticalViewCriteria_query\n  ...useRelationshipTypeCriteria_query\n  ...useVaccinationStatusCriteria_query\n}\n\nfragment VaccinationStatusesMultiSelectInput_query on Query {\n  vaccinationStatuses(orderBy: [SEQUENCE_ASC]) {\n    nodes {\n      name\n      rowId\n      id\n    }\n  }\n}\n\nfragment useActivityCriteria_query on Query {\n  currentUser {\n    activityCriteria(orderBy: [ACTIVITY_BY_ACTIVITY_ID__SEQUENCE_ASC]) {\n      nodes {\n        activityId\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment useBeliefSystemCriteria_query on Query {\n  currentUser {\n    beliefSystemCriteria(orderBy: [BELIEF_SYSTEM_BY_BELIEF_SYSTEM_ID__SEQUENCE_ASC]) {\n      nodes {\n        beliefSystemId\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment useChildrenPreferenceCriteria_query on Query {\n  currentUser {\n    childrenPreferenceCriteria(orderBy: [CHILDREN_PREFERENCE_BY_CHILDREN_PREFERENCE_ID__SEQUENCE_ASC]) {\n      nodes {\n        childrenPreferenceId\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment useCriteria_query on Query {\n  currentUser {\n    criterion {\n      ageRange {\n        start {\n          value\n        }\n        end {\n          value\n        }\n      }\n      isRecentlyActive\n      isLocationDealbreaker\n      isVerified\n      maxDistanceInKm\n      maxDistanceInMi\n      rowId\n      id\n    }\n    id\n  }\n}\n\nfragment useDeetCriteria_query on Query {\n  currentUser {\n    deetCriteria(orderBy: [DEET_BY_DEET_ID__SEQUENCE_ASC]) {\n      nodes {\n        deetId\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment useEducationLevelCriteria_query on Query {\n  currentUser {\n    educationLevelCriteria(orderBy: [EDUCATION_LEVEL_BY_EDUCATION_LEVEL_ID__SEQUENCE_ASC]) {\n      nodes {\n        educationLevelId\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment useGenderCriteria_query on Query {\n  currentUser {\n    genderCriteria(orderBy: [GENDER_BY_GENDER_ID__SEQUENCE_ASC]) {\n      nodes {\n        genderId\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment usePoliticalViewCriteria_query on Query {\n  currentUser {\n    politicalViewCriteria(orderBy: [POLITICAL_VIEW_BY_POLITICAL_VIEW_ID__SEQUENCE_ASC]) {\n      nodes {\n        politicalViewId\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment useRelationshipTypeCriteria_query on Query {\n  currentUser {\n    relationshipTypeCriteria(orderBy: [RELATIONSHIP_TYPE_BY_RELATIONSHIP_TYPE_ID__SEQUENCE_ASC]) {\n      nodes {\n        relationshipTypeId\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment useVaccinationStatusCriteria_query on Query {\n  currentUser {\n    vaccinationStatusCriteria(orderBy: [VACCINATION_STATUS_BY_VACCINATION_STATUS_ID__SEQUENCE_ASC]) {\n      nodes {\n        vaccinationStatusId\n        id\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "0b54acce47089d00eb93687a10d07f68";

export default node;
